import React from "react";
import DataTableBase from "../../../../../ui/data_tables/DataTableBase";
import ArrowIndicator from "../components/ArrowIndicator";
import {Image} from "react-bootstrap";

class DuelsDataTable extends DataTableBase {

    renderResults = (results) => {
        return (
            <div className="results">
                {results.filter(result => result.count > 0).map((result) => (<ArrowIndicator text={result.count} color={result.color}/>))}
            </div>
        );
    };

    renderDuelAgainst = (data) => {
        const {avatar, name} = data;
        return (
            <div className="duel-against">
                <Image src={avatar} roundedCircle={true}/>
                <div className="name"> {name} </div>
            </div>
        )
    };

    renderRow = (rowData, rowIndex) => {
        const {results} = rowData;
        return {
            duelAgainst: this.renderDuelAgainst(rowData),
            results: this.renderResults(results),
        };
    };

    /**
     * Returns the table columns configurations.
     * @returns *[] columns configurations.
     */
    columnsConfig = () => {
        return [{
            dataField: 'duelAgainst',
            text: 'Duel Against',
        }, {
            dataField: 'results',
            text: 'Results',
        }];
    };

    expandRowConfig = () => {
        return {
            enable: false,
        };
    };

    selectRowConfig = () => {
        return {
            enable: false,
        };
    };

    paginationConfig = () => {
        return {
            enable: false,
        };
    };

    extraClasses = {
        table: 'duels-datatable',
    };
}

export default DuelsDataTable;
